<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<div class="fx-shrink"><z-select :options="statusItem" v-model="params.status"  class="w150" @handleChange="handleGetOrderList"></z-select></div>
				<div class="fx fx-wrap fx-fill">
					<div class="fx fx-wrap m-l-10">
						<el-date-picker
						  v-model="orderTime"
					      type="datetimerange"
					      align="left"
					      placeholder="选择下单时间范围"
					      :picker-options="pickerOptions"
					      @change="handleSetTime">
					    </el-date-picker>
					</div>
				</div>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入订单号 / 微信昵称..." @handleSearch="handleGetOrderList"></z-search></div>
		</div>
		<section class="classify-table">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="(item,index) in columns">
					{{item}}
					<a 
						v-if="index==2"
						:class="[params.orderBy=='pay_fee:ASC'?'up-sort':params.orderBy=='pay_fee:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('pay_fee')">
					</a>
				</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>{{item.order_no}}</td>
					<td>{{item.nickname}}</td>
					<td>{{item.pay_money | filterMoney}}</td>
					<td :class="[item.status == 1?'success':item.status == 3 ? 'fail': 'ing']">
						{{item.status | filterOrderStatus}}
					</td>
					<td>{{item.c_time | momentFmt}}</td>
					<td>{{item.pay_time | momentFmt}}</td>
					<td class="operating">
						<router-link  class="operat-btn" tag="a" :to="{ name: 'vOrderDetail',query:{id:item.id}}"><i class="icon-look"></i><span>查看详情</span></router-link>
						<!--<a class="operat-btn" @click="handleOrderInfo(item.id)"><i class="icon-look"></i><span>查看详情</span></a>-->
					</td>
				</tr>
			</z-table>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'Order',
		components: {},
		data() {
			return {
				isDisableDown: false,//是否继续下载
				columns :['订单号','昵称', '支付金额（元）', '状态', '下单时间','支付时间', '操作'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',
					status: '',
					orderBy: "l_time:DESC",
					beginTime:'',
					endTime:''
				},
				orderTime:[null,null],
				statusItem: [{
					value: '',
					text: '请选择状态'
				}, {
					value: 0,
					text: '关闭'
				}, {
					value: 1,
					text: '支付成功'
				}, {
					value: 2,
					text: '待支付'
				}, {
					value: 3,
					text: '已发货'
				}, {
					value: 4,
					text: '退款中'
				}, {
					value: 5,
					text: '退款成功'
				}],
				pickerOptions: {
		        		shortcuts: [{
			            text: '最近一周',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			              picker.$emit('pick', [start, end]);
			            }
		          	}, {
			            text: '最近一个月',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			              picker.$emit('pick', [start, end]);
			            }
		          	}, {
		            		text: '最近三个月',
		            		onClick(picker) {
			              	const end = new Date();
			              	const start = new Date();
			              	start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			              	picker.$emit('pick', [start, end]);
		            		}
		          	}]
		        },
		        isPopExport: false,
		        pageTarget: '',
		        pageNum: []
			}
		},
//		filters: {
//			orderStatus(status) {
//				switch(status) {
//					case 0:
//						return '已关闭';
//						break;
//					case 1:
//						return '待支付';
//						break;
//					case 2:
//						return '已支付';
//						break;
//					case 3:
//						return '已发货';
//						break;
//					case 4:
//						return '退款中';
//						break;
//					case 5:
//						return '退款成功';
//						break;
//				}
//			}
//		},
		computed: {
			...mapState({
				list: state => state.vmall.orderList
			})
		},
		mounted() {
			this.handleGetOrderList();
		},
		methods: {
			//排序
			handleListByOrder(orderBy) {
				if (this.params.orderBy == 'l_time:DESC') {
					this.params.orderBy = orderBy + ':ASC';
				} else {
					this.params.orderBy = this.params.orderBy == orderBy + ':ASC' ? orderBy + ':DESC' : orderBy + ':ASC';
				}
				
				this.handleGetOrderList();
			},
			
			//获取订单列表
			handleGetOrderList(offset = 0) {
				this.params.beginTime = this.orderTime[0]
				this.params.endTime = this.orderTime[1]
				this.params.offset = offset;
				this.getOrderList(this.params)
			},
			handleSetTime(){
				this.handleGetOrderList();
			},
			//处理分页
			handleOffset(offset) {
				this.handleGetOrderList(offset);
			},
			
//			//获取订单详情
//			handleOrderInfo(orderId) {
//				this.$router.push({ name: 'vmallOrderInfo', query: { orderId: orderId} });
//			},
			
			...mapActions(['getOrderList', 'getOrderInfo', 'getVmallOrderCount', 'exportVmallOrderList']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	table .operating{
		i,span{
			height: 18px;
			line-height: 18px;
			width: 60px !important;
		}
	}
	.arrow{
		position: relative;
		&:before,&:after{
			content: "";
			position: absolute;
			width: 0;
			height: 0;
		}
		&:before{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-bottom: 6px solid $color-border;
		    top: -0;
		    left: 0;
		}
		&:after{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-top: 6px solid $color-border;
		    bottom: -0px;
		    left: 0;
		}
		&.up-sort{
			&:before{
				border-bottom-color: $color-main;
			}
		}
		&.down-sort{
			&:after{
				border-top-color: $color-main;
			}
		}
	}
	.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	td{
		&.success{
			color: $color-success;
		}
		&.ing{
			color:$color-warning;
		}
		&.fail{
			color: $color-wrong;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1400px);
		}
	}
</style>


// WEBPACK FOOTER //
// Order.vue?7deafa69